<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-12-30 18:20:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/product/detail/components/SpuName/index.vue
-->
<template>
  <div class="con text_left">
    <div class="sku_title font16 font_weight600 colo087">
      {{ mallretailspu.name }}
    </div>
    <div class="sku_det font12 font_weight400 colo055">
      {{ mallretailspu.resume }}
    </div>
    <div
      :class="{ pad_bot12: mallretailspu.tradeType === 2 }"
      class="sku_price clearfix"
    >
      <div class="left">
        <div class="font16 font_weight600 colof00 now_price">
          {{ mallretailspu.storePrice | currency(false) }}
        </div>
        <div class="font14 font_weight500 colo038 old_price">
          {{ mallretailspu.crossedPrice | currency(false) }}
        </div>
      </div>
      <div class="left sku_tags">
        <tags
          :tradeType="mallretailspu.tradeType"
          :includeTax="mallretailspu.includeTax"
        />
      </div>
      <!-- <div class="font10 font_weight400 colo055 right">
        <div class="sku_num">销量：{{ mallretailspu.salesVolume }}</div>
      </div> -->
    </div>
    <div
      v-if="mallretailspu.tradeType !== 2"
      class="clearfix pofit"
      @click="showTax"
    >
      <div class="font12 font_weight400 colo055 pofit_det left">
        <span>进口税</span>
        <!-- <span v-if="mallretailspu.includeTax === 1">已包税</span> -->
        <span>预计：{{ mallretailspu.taxRat | currency(false) }}</span>
      </div>
      <img
        src="@/assets/common/icon_back_b87_24@2x.png"
        alt=""
        class="right_icon right"
      />
    </div>
    <!-- 税费说明 -->
    <tax-action-sheet v-if="showTaxSheet" @closeSheet="closeSheet" />
  </div>
</template>
<script>
const Tags = () => import("@/components/Tags").then(m => m.default || m);
const TaxActionSheet = () =>
  import("../TaxActionSheet").then(m => m.default || m);
export default {
  components: {
    Tags,
    TaxActionSheet
  },
  data() {
    return {
      showTaxSheet: false
    };
  },
  computed: {
    mallretailspu() {
      return this.$store.getters.mallretailspu;
    }
  },
  methods: {
    showTax() {
      this.showTaxSheet = true;
      // console.log(this.showTaxSheet);
    },
    closeSheet() {
      this.showTaxSheet = false;
    }
  }
};
</script>
<style lang="less" scoped>
.con {
  background: #fff;
  padding: 0 10px;
  border-radius: 0px 0px 6px 6px;
  .sku_title {
    padding-top: 12px;
  }
  .sku_det {
    padding-top: 8px;
  }
  .sku_price {
    margin-top: 8px;
  }
  .pad_bot12 {
    padding-bottom: 12px;
  }
  .now_price {
    line-height: 26px;
  }
  .old_price {
    margin-top: 4px;
    line-height: 16px;
    text-decoration: line-through;
  }
  .pofit {
    padding: 5px 0 10px;
  }
  .pofit_det {
    margin-top: 3px;
  }
  .sku_tags {
    margin: 8px 0 0 10px;
  }
  .sku_num {
    margin-top: 10px;
  }
  .right_icon {
    width: 24px;
  }
}
</style>
